"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _constants = require("../constants");
var _default = exports.default = function _default(localString) {
  return localString === _constants.LOCAL;
};